export default "__VITE_ASSET__DmQb6rZ3__";